import React from 'react'

import { ConfigProvider } from 'antd'
import locale from 'antd/lib/locale/pt_BR'
import RedirectTo from 'Components/RedirectTo'
import { ApplicationProvider } from 'Context'
import ModoEnum from 'Enumerations/ModoEnum'
import AuthLayout from 'Layouts/Auth'
import LayoutDocas from 'Layouts/Docas'
import LayoutMisto from 'Layouts/LayoutMisto'
import ReactDOM from 'react-dom'
import { Routes, Route, HashRouter } from 'react-router-dom'
import SnackbarProvider from 'react-simple-snackbar'
import { authentication } from 'Routes'
import 'antd/dist/antd.less'
import 'moment/locale/pt-br'
import SessionClosed from 'Views/Auth/SessionClosed'

ReactDOM.render(
  <React.StrictMode>
    <ApplicationProvider>
      <ConfigProvider locale={locale}>
        <SnackbarProvider>
          <HashRouter>
            <Routes>
              <Route path="/" element={<RedirectTo to="/auth" />} />
              <Route
                path={`/${authentication.root}/*`}
                element={<AuthLayout />}
              />
              <Route
                path="/Docas"
                element={<LayoutDocas modo={ModoEnum.Normal} />}
              />
              <Route
                path="/DocasIraniFob"
                element={<LayoutDocas modo={ModoEnum.IraniFob} />}
              />
              <Route path="/session-close" element={<SessionClosed />} />
              <Route path="/*" element={<LayoutMisto />} />
            </Routes>
          </HashRouter>
        </SnackbarProvider>
      </ConfigProvider>
    </ApplicationProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
